'use client';

import clsx from "clsx";
import { useRef } from "react";


interface HamburgerProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
  hideOnDesktop?: boolean;
};

const Hamburger = ({ setIsOpen, isOpen }: HamburgerProps) => {
  const hamburgerRef = useRef<HTMLButtonElement>(null);

  const openNavigation = () => {
    setIsOpen(!isOpen);
  };

  return (
    <button ref={hamburgerRef} onClick={openNavigation} className={clsx('hamburger', isOpen && 'is-active')} aria-label="Menu" aria-haspopup="true" aria-expanded={isOpen ? true : false}>
      <span className="line"></span>
    </button>
  );
};
Hamburger.displayName = 'Hamburger';

export { Hamburger };